import { builderFragment, rowsFragment } from './fragments.gql'

export default `query {
  careersPage {
    jobListings {
      id
      title
      department
      deadline
      location
      blurb
      link
    }
    ${builderFragment}
    rowsAbove ${rowsFragment}
  }
}`
